import React from "react";
import styled from "styled-components";
import { SectionHeader } from "../../../../app/components";
import { useNavigate, useParams } from "react-router-dom";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import EditIcon from "@material-ui/icons/Edit";
import ScenarioA from "./scenario.a";
import ScenarioB from "./scenario.b";
import SeparateContainer from "../../../../app/components/separate.Container";
import OutlinedButton from "../../../../app/components/buttons/outlined";
import SideBySide from "../../../../app/components/sideBySide";

const OverallParameters = () => {
  const navigate = useNavigate();
  const { id, planId } = useParams();
  const { studyPlan, STUDY_PLAN_TYPES, canEditPlan } = useStudyPlan();

  const { studyPlanType } = studyPlan;
  const { SCENARIO_A, SCENARIO_B } = STUDY_PLAN_TYPES;
  let scenarioRender;
  if (studyPlanType === SCENARIO_A) {
    scenarioRender = <ScenarioA />;
  }

  if (studyPlanType === SCENARIO_B) {
    scenarioRender = <ScenarioB />;
  }

  return (
    <SeparateContainer>
      <Container>
        <SideBySide>
          <SectionHeader
            paddingBottom={false}
            marginBottom={false}
          >
            Overall Study Inputs
          </SectionHeader>
          {canEditPlan && (
            <OutlinedButton
              style={{ marginBlock: "0.7em", marginInline: "1em" }}
              onClick={() =>
                navigate(`/ctpo/study-plans/${id}/${planId}#overall-inputs`)
              }
            >
              <EditIcon style={{ marginRight: ".3em" }} /> Edit
            </OutlinedButton>
          )}
        </SideBySide>
        <div style={{ padding: "20px" }}>
          <Content>{scenarioRender}</Content>
        </div>
      </Container>
    </SeparateContainer>
  );
};

export default OverallParameters;

const Container = styled.div``;
const Content = styled.div``;
